import { Parser } from 'html-to-react';

const htmlToReactParser = new Parser();

const renderHtml = (htmlInput?: string | null) =>
  htmlInput ? htmlToReactParser.parse(htmlInput) : '';

export default renderHtml;
